module.exports = __webpack_public_path__ + "static/media/user_agreement.7b8ed6db.htm";